
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-green-700 mb-4">
              elämäni
            </div>
            <p className="text-gray-600 mb-4">
              日本の森林から採られた精油を用いたアロマセラピー教室/トリートメントサロン
            </p>
            <div className="flex space-x-4">
              <Link to="/contact" className="w-8 h-8 flex items-center justify-center">
                <i className="ri-mail-line text-green-600 cursor-pointer"></i>
              </Link>
              <a 
                href="https://www.instagram.com/elamani_aroma?igsh=MWJ5ODZtMTZ1bGJybQ%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center"
              >
                <i className="ri-instagram-line text-green-600 cursor-pointer"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">講座/サービス案内</h3>
            <ul className="space-y-2">
              <li><Link to="/courses" className="text-gray-600 hover:text-green-600 cursor-pointer">日本産精油クラフト講座</Link></li>
              <li><Link to="/courses" className="text-gray-600 hover:text-green-600 cursor-pointer">yuica認定日本産精油アドバイザー資格講座</Link></li>
              <li><Link to="/treatment" className="text-gray-600 hover:text-green-600 cursor-pointer">日本産精油トリートメント</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">アクセス</h3>
            <div className="text-gray-600 space-y-2">
              <p>〒162-0056</p>
              <p>東京都新宿区若松町</p>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">お問い合わせ</h3>
            <div className="space-y-2">
              <p className="flex items-center text-gray-600">
                <i className="ri-mail-line mr-2"></i>
                healthcoach.yoshiko@gmail.com
              </p>
              <p className="flex items-center text-gray-600">
                <i className="ri-line-fill mr-2"></i>
                <a 
                  href="https://lin.ee/efJX94s" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-green-600 cursor-pointer"
                >
                  LINEでお問い合わせ
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © 2025 elämäni. All rights reserved.
          </p>
          <a 
            href="https://elamaniaroma.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-green-600 cursor-pointer mt-2 md:mt-0"
          >
            elämäni 日本産精油のアロマセラピー教室/トリートメントサロン
          </a>
        </div>
      </div>
    </footer>
  );
}
